import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { gaPageView } from './analytics'

export default function usePageTracking() {
  const location = useLocation()
  useEffect(() => {
    gaPageView(location.pathname + location.search, document.title)
  }, [location])
}
